import { takeEvery, put, call, select } from "redux-saga/effects";

import {
  LOAD_CLIPS,
  putSchedule,
} from "../../../store/Settings/actions/components/Clips";

import { showAlertError } from "../../../store/Alert/actions";

import axios from "axios";

export default function* () {
  yield takeEvery(LOAD_CLIPS, worker);
}

function* worker({ payload }) {
  try {
    const { cache, trackObjects } = yield select((state) => ({
      cache: state.settings.clips || {},
      trackObjects: state.objects.allObjectsAssociated,
    }));

    let objectsClips;

    if (payload) {
      let { indentId, indentIds, objectIds, required } = payload;

      if (!objectIds?.length) return;

      // ✅ фикс: нормализация indentIds
      const ids = indentIds || (indentId ? [indentId] : []);

      if (!ids.length) return;

      objectsClips = yield call(getObjectClips, {
        indentIds: ids,
        objectIds,
        required,
        trackObjects,
        cache,
      });
    } else {
      const { objectIds, indentIds } = yield select((state) => ({
        objectIds: state.objects.selected,
        indentIds: state.tracks.selected,
      }));

      objectsClips = yield call(getObjectClips, {
        indentIds,
        objectIds,
        trackObjects,
        cache,
        required: true,
      });
    }

    if (!objectsClips) return;

    if (objectsClips.error) {
      return yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${LOAD_CLIPS}.`, objectsClips],
          text: "Расписание не было загружено. " + objectsClips.error,
        })
      );
    }

    yield put(putSchedule(objectsClips));
  } catch (e) {
    console.log({ e });

    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${LOAD_CLIPS}.`, e],
        text: "Расписание не было загружено. Попробуйте перезагрузить страницу.",
      })
    );
  }
}

// =======================
// API
// =======================

function* getObjectClips({
  indentIds,
  objectIds,
  required,
  trackObjects,
}) {
  if (!indentIds?.length) return;

  const response = yield call(fetchClips, indentIds, objectIds);

  if (!response || response.error) {
    return response;
  }

  return groupByMsId(response, trackObjects);
}

function fetchClips(indentIds, ms_ids) {
  const formData = new FormData();

  if (ms_ids) {
    ms_ids.forEach((id) => formData.append("ms_id[]", id.toString()));
  }

  indentIds.forEach((id) =>
    formData.append("indent_id[]", id.toString())
  );

  return axios({
    url: `/timeline/clip/review`,
    method: "POST",
    data: formData,
  }).then((response) => response.data);
}

// =======================
// TRANSFORM
// =======================

function groupByMsId(data, trackLookup) {
  const result = {};
  const indentMap = data.success.indent;

  for (const indentId in indentMap) {
    const msEntries = indentMap[indentId];

    for (const msId in msEntries) {
      if (!result[msId]) {
        result[msId] = {
          object: trackLookup[msId] || {},
          schedule: [],
        };
      }

      for (const entry of msEntries[msId]) {
        const { indent_id, mark, alias, ...scheduleData } = entry;

        const existingSchedule = result[msId].schedule.find((s) => {
          if (mark !== null) {
            return s.mark === mark && s.alias === alias;
          } else {
            return (
              s.fromdate === scheduleData.fromdate &&
              s.todate === scheduleData.todate &&
              s.fromtime === scheduleData.fromtime &&
              s.totime === scheduleData.totime &&
              s.indent_ids.includes(indent_id)
            );
          }
        });

        if (existingSchedule) {
          if (!existingSchedule.indent_ids.includes(indent_id)) {
            existingSchedule.indent_ids.push(indent_id);
          }
        } else {
          result[msId].schedule.push({
            ...scheduleData,
            mark,
            alias,
            indent_ids: [indent_id],
          });
        }
      }
    }
  }

  return result;
}